export default "/images/dansk_boligforsikring.webp?4bcf8ff6263f05e8bcda5bb2e3368d5f";